export const STATUS_TAB_PARAM = "status";
export const STATUS_TAB_REBALANCE_PARAM = "rebalance";

type StatusTabUpdateOptions = {
  status?: string | null;
  rebalance?: boolean;
};

export const updateStatusTabSearch = (
  currentSearch: string,
  options: StatusTabUpdateOptions = {},
) => {
  const params = new URLSearchParams(currentSearch);

  if (options.status === null) {
    params.delete(STATUS_TAB_PARAM);
  } else if (options.status !== undefined) {
    params.set(STATUS_TAB_PARAM, options.status);
  }

  if (options.rebalance) {
    params.set(STATUS_TAB_REBALANCE_PARAM, "1");
  } else {
    params.delete(STATUS_TAB_REBALANCE_PARAM);
  }

  const search = params.toString();
  return search ? `?${search}` : "";
};

export const buildPathWithStatusTabSearch = (
  basePath: string,
  currentSearch: string,
  options: StatusTabUpdateOptions = {},
) => `${basePath}${updateStatusTabSearch(currentSearch, options)}`;

export const hasExplicitStatusTabRebalance = (search: string) => {
  const params = new URLSearchParams(search);
  return params.get(STATUS_TAB_REBALANCE_PARAM) === "1";
};
